import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

import Select from '../../../components/ui/Select';

const AccountToolbar = ({ 
  searchQuery, 
  onSearchChange, 
  selectedType, 
  onTypeChange,
  onAddAccount,
  onBulkImport,
  onExport 
}) => {
  const accountTypeOptions = [
    { value: '', label: 'All Types' },
    { value: 'Asset', label: 'Assets' },
    { value: 'Liability', label: 'Liabilities' },
    { value: 'Equity', label: 'Equity' },
    { value: 'Income', label: 'Income' },
    { value: 'Expense', label: 'Expenses' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6 space-y-4">
      <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
        <div className="flex-1 w-full lg:max-w-md">
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" 
            />
            <input
              type="text"
              placeholder="Search accounts by code or name..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full pl-10 pr-4 py-2 md:py-3 rounded-md border border-input bg-background text-foreground text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-ring transition-smooth"
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3 w-full lg:w-auto">
          <div className="w-full sm:w-48">
            <Select
              options={accountTypeOptions}
              value={selectedType}
              onChange={onTypeChange}
              placeholder="Filter by type"
            />
          </div>

          <Button
            variant="outline"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
          >
            <span className="hidden md:inline">Export</span>
          </Button>

          <Button
            variant="secondary"
            onClick={onBulkImport}
            iconName="Upload"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
          >
            <span className="hidden md:inline">Import</span>
          </Button>

          <Button
            variant="default"
            onClick={onAddAccount}
            iconName="Plus"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
          >
            Add Account
          </Button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 md:gap-3 items-center">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 md:w-4 md:h-4 border-l-4 border-primary rounded-sm"></div>
          <span className="caption text-muted-foreground">Has Activity</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 md:w-4 md:h-4 bg-muted rounded-sm opacity-50"></div>
          <span className="caption text-muted-foreground">Inactive</span>
        </div>
      </div>
    </div>
  );
};

export default AccountToolbar;